import React, {useEffect} from 'react';
import CustomCard from "../../../components/generic/CustomCard";
import {theme} from "../../../style/theme";
import Grid from "@mui/material/Grid";
import {useSelector} from "react-redux";
import {dispatchToStore} from "../../../store/configureStore";
import {useParams} from "react-router";
import {Button, Stack, TextField} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import {Link as RouterLink} from "react-router-dom";
import SaveIcon from '@mui/icons-material/Save';
import {stockPropertiesDelete, stockPropertiesLoad} from "../../../store/slices/stock/properties";


export default function PropertiesDeletePage() {

    const {selectedPropertyId} = useParams()

    const propertyList = useSelector(store => store.stockProperties.items)

    useEffect(() => {
        // loading page effect
        dispatchToStore(stockPropertiesLoad({}))

        // unloading page effect
        return () => {

        }

    }, []);

    const property = propertyList[selectedPropertyId]

    function onDeleteItemRow(row) {
        dispatchToStore(stockPropertiesDelete({
            property_id: row["property_id"],
            desc: row["desc"],
            type: row["type"],
        }))
    }

    return (
        <Grid container spacing={theme.spacing(4)} sx={{padding: theme.spacing(2)}}>
            <Grid item xs={12}>
                <CustomCard caption={"Delete Property"}>
                    <Stack direction={"column"} spacing={2}>

                        <TextField id={"name"} label={"Name"} value={property["desc"]}
                                disabled={true} />

                        <TextField id={"type"} label={"Type"} value={property["type"]}
                                   disabled={true} />


                        <TextField id={"modified_at"} label={"Modified at"} value={property["modified_at"]}
                                   disabled={true} />

                        <Stack direction={"row"} alignItems={"center"} gap={1} justifyContent={"center"}>

                            <Button size={"large"}
                                    color={"primary"}
                                    sx={{marginTop: 4}}
                                    component={RouterLink}
                                    to={'/settings/properties'}

                                    onClick={() => {
                                        onDeleteItemRow(property)
                                    }}>
                                <SaveIcon sx={{marginRight: 2}}/>
                                Delete
                            </Button>

                            <Button size={"large"}
                                    color={"primary"}
                                    sx={{marginTop: 4}}
                                    component={RouterLink}
                                    variant={"outlined"}
                                    to={'/settings/properties'}

                                    onClick={() => {

                                    }}>
                                <CloseIcon sx={{marginRight: 2}}/>
                                Cancel
                            </Button>


                        </Stack>
                    </Stack>
                </CustomCard>
            </Grid>

        </Grid>

    )


}

